// extracted by mini-css-extract-plugin
export var avatarContainer = "_8s-0";
export var avatarTypingWave = "_8s-i";
export var gray = "_8s-f";
export var green = "_8s-c";
export var icon = "_8s-9";
export var image = "_8s-1";
export var lg = "_8s-6";
export var md = "_8s-5";
export var presenceDot = "_8s-b";
export var red = "_8s-d";
export var sm = "_8s-4";
export var status = "_8s-a";
export var typingDot = "_8s-h";
export var typingPill = "_8s-g";
export var xl = "_8s-7";
export var xs = "_8s-3";
export var xxl = "_8s-8";
export var xxs = "_8s-2";
export var yellow = "_8s-e";